import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

/**
 * Returns a sign-out callback: POST /auth/logout, invalidate the `['me']`
 * cache, then route home. Mirrors the inline logout in AuthMenu.tsx so the
 * mobile chrome (Drawer, tab-bar Account sheet) can sign out without us having
 * to modify the shared desktop AuthMenu component.
 */
export function useSignOut(): () => void {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return () => {
    void fetch(
      `${(import.meta.env.VITE_API_BASE_URL ?? "https://api.sportsacademygames.com").replace(/\/$/, "")}/auth/logout`,
      { method: "POST", credentials: "include" },
    ).finally(() => {
      void queryClient.invalidateQueries({ queryKey: ["me"] });
      navigate("/");
    });
  };
}
